import * as React from "react"
const IconGInfo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#141938"
      d="M8.005 14.007a6.004 6.004 0 0 1-6.001-6.002 6.004 6.004 0 0 1 6.001-6.001 6.004 6.004 0 0 1 6.002 6.001 6.01 6.01 0 0 1-6.002 6.002Zm0-11.001a5 5 0 0 0 0 9.998 5 5 0 0 0 5-4.999c0-2.76-2.25-5-5-5Zm.992 6.993h-.245V7.494a.502.502 0 0 0-.501-.501h-.747a.502.502 0 0 0 0 1.002h.246v2.004h-.246a.502.502 0 0 0 0 1.002h1.503a.502.502 0 0 0 .501-.501.51.51 0 0 0-.511-.501Zm-.992-3.497c.42 0 .747-.337.747-.746a.744.744 0 0 0-.747-.746.744.744 0 0 0-.746.746.738.738 0 0 0 .746.746Z"
    />
  </svg>
)
export default IconGInfo
